import HeroCarousel from '../../Components/Home/Hero/HeroCarousel'
import WhatIsDailyvents from '../../Components/Home/Main/WhatIsDailyvents/WhatIsDailyvents'
import HowItWorks from '../../Components/Home/Main/HowItWorks/HowItWorks'
import WhyLove from '../../Components/Home/Main/WhyLove/WhyLove'
import EventsNearMe from '../../Components/Home/Main/EventsNearMe/EventsNearMe'
import TryOut from '../../Components/Home/Main/TryOut/TryOut'
import FAQ from '../../Components/Home/Main/FAQ/FAQ'
import ReadyToPlay from '../../Components/Home/Main/ReadyToPlay/ReadyToPlay'
import { useModalStore } from '../../store/ModalStore'
import { useModalDataStore } from '../../store/ModalDataStore'
import { MODAL_STATE } from '../../types/modals'
import { EventData } from '../../types/events'

const Home = () => {
    const { openModal } = useModalStore()
    const { setData } = useModalDataStore()

    return (
        <>
            <HeroCarousel />

            {/* Main Content */}
            <div className="main-content">
                <WhatIsDailyvents
                    onGetStarted={() => openModal(MODAL_STATE.TRY_IT)}
                />
                <HowItWorks />
                <WhyLove
                    onFootballClick={() => openModal(MODAL_STATE.FOOTBALL)}
                    onVolleyballClick={() => openModal(MODAL_STATE.VOLLEYBALL)}
                />
                <EventsNearMe
                    onSportEventClick={(event: EventData) => {
                        setData(event)
                        openModal(MODAL_STATE.SPORT_EVENT)
                    }}
                    onOthersClick={() => openModal(MODAL_STATE.OTHERS)}
                    onViewMoreClick={() => openModal(MODAL_STATE.TRY_IT)}
                />
                <TryOut />
                <FAQ
                    onContactUsClick={() => openModal(MODAL_STATE.CONTACT_US)}
                />
                <ReadyToPlay />
            </div>
        </>
    )
}

export default Home
